export class Despertador {
    public del:string='';
    public al:string='';
    public id:number=0;
    public nombre:string='';
    public hora:string='';
}
